import React, { useEffect, useState } from 'react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-[36px] left-0 w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-[#0A0A0A]/90 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`} data-id="element-101">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex justify-center items-center" data-id="element-102">
        <a href="#" className="text-2xl font-black tracking-tighter text-white uppercase italic" data-id="element-103">
          Enfocado<span className="text-[#FF6B35]" data-id="element-104">.</span>
        </a>
      </div>
    </header>;
}